(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.documentElement.classList.add('wagzivo-ready');

  const revealItems = document.querySelectorAll('.wz-reveal');
  if (revealItems.length && !reduceMotion && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.12 }
    );
    revealItems.forEach((item) => observer.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }

  document.querySelectorAll('[data-wz-slider]').forEach((slider) => {
    const slides = [...slider.querySelectorAll('[data-wz-slide]')];
    const dots = [...slider.querySelectorAll('[data-wz-dot]')];
    const prev = slider.querySelector('[data-wz-prev]');
    const next = slider.querySelector('[data-wz-next]');
    const isNarrowViewport = window.matchMedia('(max-width: 749px)').matches;
    const autoplay = slider.dataset.autoplay === 'true' && !reduceMotion && !isNarrowViewport;
    let index = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let timer;
    let startX = 0;

    const setSlide = (nextIndex) => {
      if (!slides.length) return;
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === index;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });
      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === index);
        dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
      });
    };

    const stop = () => {
      window.clearInterval(timer);
    };

    const start = () => {
      if (!autoplay || slides.length < 2) return;
      stop();
      timer = window.setInterval(() => setSlide(index + 1), 7000);
    };

    prev?.addEventListener('click', () => {
      stop();
      setSlide(index - 1);
    });
    next?.addEventListener('click', () => {
      stop();
      setSlide(index + 1);
    });
    dots.forEach((dot, dotIndex) => {
      dot.addEventListener('click', () => {
        stop();
        setSlide(dotIndex);
      });
    });
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('touchstart', (event) => {
      startX = event.changedTouches[0]?.clientX || 0;
      stop();
    }, { passive: true });
    slider.addEventListener('touchend', (event) => {
      const endX = event.changedTouches[0]?.clientX || 0;
      if (Math.abs(endX - startX) > 42) {
        setSlide(endX < startX ? index + 1 : index - 1);
      }
    }, { passive: true });
    slider.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        stop();
        setSlide(index - 1);
      }
      if (event.key === 'ArrowRight') {
        stop();
        setSlide(index + 1);
      }
    });

    setSlide(index);
    start();
  });

  const mobileAtc = document.querySelector('[data-wz-mobile-atc]');
  const mainProduct = document.querySelector('product-info[data-update-url="true"]');
  if (mobileAtc && mainProduct) {
    const mobileButton = mobileAtc.querySelector('button');
    const mainButton = () => mainProduct.querySelector('product-form button[type="submit"]');
    const syncMobileAtc = () => {
      const button = mainButton();
      mobileAtc.hidden = !button;
      if (!button) return;
      mobileButton.disabled = button.disabled || button.getAttribute('aria-disabled') === 'true';
      const price = mainProduct.querySelector('[id^="price-"] .price');
      const priceText = price?.querySelector(price.classList.contains('price--on-sale') ? '.price-item--sale' : '.price-item--regular')?.textContent.trim();
      mobileButton.textContent = button.disabled
        ? button.textContent.trim()
        : `Add to cart${priceText ? ` - ${priceText}` : ''}`;
    };
    // Reuse the main form so variants, quantities, validation and cart events cannot drift.
    mobileButton.addEventListener('click', () => mainButton()?.click());
    new MutationObserver(syncMobileAtc).observe(mainProduct, {
      childList: true, subtree: true, characterData: true,
      attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'],
    });
    syncMobileAtc();
  }

  const copyText = async (text) => {
    if (navigator.clipboard?.writeText && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(text);
        return;
      } catch (error) {
        // Fall back below when clipboard permissions are blocked.
      }
    }

    const input = document.createElement('textarea');
    input.value = text;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.appendChild(input);
    input.select();
    const copied = document.execCommand('copy');
    input.remove();
    if (!copied) throw new Error('Copy command failed');
  };

  document.addEventListener('click', (event) => {
    const checkoutLink = event.target.closest('[data-wz-direct-checkout]');
    if (!checkoutLink) return;

    const productInfo = checkoutLink.closest('product-info') || document;
    const variantInput = productInfo.querySelector('input.product-variant-id[name="id"], form[action*="/cart/add"] input[name="id"]');
    const quantityInput = productInfo.querySelector('input[name="quantity"]');
    const variantId = variantInput?.value || checkoutLink.dataset.wzVariantId;
    const quantity = Math.max(1, Number.parseInt(quantityInput?.value || '1', 10) || 1);
    const discountCode = checkoutLink.dataset.wzDiscountCode;

    if (!variantId) return;

    event.preventDefault();
    const rootUrl = window.routes?.root_url || '/';
    const discountQuery = discountCode ? `?discount=${encodeURIComponent(discountCode)}` : '';
    window.location.href = `${rootUrl}cart/${variantId}:${quantity}${discountQuery}`;
  });

  document.addEventListener('click', async (event) => {
    const copyButton = event.target.closest('[data-wz-copy-code]');
    if (!copyButton) return;

    const code = copyButton.dataset.wzCopyCode;
    const originalText = copyButton.dataset.wzOriginalText || copyButton.textContent.trim();
    if (!code) return;

    copyButton.dataset.wzOriginalText = originalText;
    try {
      await copyText(code);
      copyButton.textContent = `Copied ${code}`;
      copyButton.classList.add('is-copied');
      window.setTimeout(() => {
        copyButton.textContent = originalText;
        copyButton.classList.remove('is-copied');
      }, 2200);
    } catch (error) {
      copyButton.textContent = code;
    }
  });
})();
